import { ArrowNarrowDownIcon, ArrowNarrowUpIcon } from '@heroicons/react/solid';
import { default as classNames, default as cx } from 'classnames';
import { getDeltaTextClassNames } from '../utils/getDeltaTextClassNames';
import TooltipUncontrolled from './TooltipUncontrolled';

export type DataQuadrantCellProps = {
  value?: string | number | React.ReactNode;
  label: string;
  tooltip: React.ReactNode;
  className?: string;
  borderBottom?: boolean;
  borderRight?: boolean;
  delta?: number | null;
  tooltipPosition?: 'top' | 'bottom' | 'left' | 'right';
};

export function DataQuadrantCell({
  value = '—',
  label,
  tooltip,
  className,
  borderBottom = false,
  borderRight = false,
  delta,
  tooltipPosition = 'left',
}: DataQuadrantCellProps) {
  return (
    <div
      className={cx(
        'yst-relative yst-flex yst-flex-col yst-items-center yst-gap-1 yst-p-4 yst-text-center',
        borderBottom && 'yst-border-b yst-border-slate-200',
        borderRight && 'yst-border-r yst-border-slate-200',
        className,
      )}
    >
      <p className="yst-text-2xl yst-font-bold yst-text-slate-900">{value}</p>
      <p className="yst-text-tiny yst-text-slate-600">{label}</p>
      {typeof delta === 'number' && (
        <p
          className={classNames(
            'yst-flex yst-items-center yst-gap-1 yst-text-tiny yst-font-bold',
            getDeltaTextClassNames(delta),
          )}
        >
          {delta > 0 ? (
            <ArrowNarrowUpIcon />
          ) : delta < 0 ? (
            <ArrowNarrowDownIcon />
          ) : null}
          {delta > -0.000001 && '+'}
          {delta}
        </p>
      )}
      {tooltip && (
        <TooltipUncontrolled
          id={`tooltip-${label.replace(/\s+/g, '-').toLowerCase()}`}
          className="yst-absolute yst-right-2 yst-top-2"
          position={tooltipPosition}
        >
          {tooltip}
        </TooltipUncontrolled>
      )}
    </div>
  );
}

export type DataQuadrantProps = {
  children: React.ReactNode;
  className?: string;
};

export default function DataQuadrant({
  children,
  className,
}: DataQuadrantProps) {
  return (
    <div
      className={cx(
        'yst-grid yst-w-full yst-grid-cols-2 yst-gap-0 yst-rounded-lg',
        className,
      )}
    >
      {children}
    </div>
  );
}
